var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOriginalTaste(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 36,
    viewBox: "0 0 39 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.8692 5.37783L37.1047 19.645C41.2419 26.811 36.0698 35.7675 27.7953 35.7675H11.3243C3.04976 35.7675 -2.12235 26.811 2.0149 19.645L10.2526 5.37783C14.3899 -1.78821 24.7319 -1.78821 28.8692 5.37783Z",
    fill: "#00D1D2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8219 28.8376C31.0849 28.8376 33.7301 26.1924 33.7301 22.9294C33.7301 19.6664 31.0849 17.0212 27.8219 17.0212C24.5589 17.0212 21.9137 19.6664 21.9137 22.9294C21.9137 26.1924 24.5589 28.8376 27.8219 28.8376Z",
    fill: "white",
    stroke: "#1A1A18",
    strokeWidth: 1.08248,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9157 22.9294C21.9157 22.9294 22.9982 13.566 23.797 12.1522C24.3816 11.1217 25.4879 10.4246 26.7565 10.4246C27.7914 10.4246 28.718 10.8879 29.3415 11.6153C29.8503 12.2085 33.1627 20.3964 33.1627 20.3964",
    stroke: "#1A1A18",
    strokeWidth: 1.08248,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0156 16.4085C23.0156 16.4085 26.6462 13.462 31.0325 15.7504",
    stroke: "#1A1A18",
    strokeWidth: 1.08248,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.301 28.8377C14.564 28.8377 17.2092 26.1925 17.2092 22.9295C17.2092 19.6665 14.564 17.0213 11.301 17.0213C8.03797 17.0213 5.39278 19.6665 5.39278 22.9295C5.39278 26.1925 8.03797 28.8377 11.301 28.8377Z",
    fill: "white",
    stroke: "#1A1A18",
    strokeWidth: 1.08248,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2089 22.9294C17.2089 22.9294 16.1264 13.566 15.3275 12.1522C14.743 11.1217 13.6367 10.4246 12.368 10.4246C11.3332 10.4246 10.4065 10.8879 9.78303 11.6153C9.27427 12.2085 5.96187 20.3964 5.96187 20.3964",
    stroke: "#1A1A18",
    strokeWidth: 1.08248,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.107 16.4085C16.107 16.4085 12.4764 13.462 8.09013 15.7504",
    stroke: "#1A1A18",
    strokeWidth: 1.08248,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3799 15.3391H22.7752",
    stroke: "#1A1A18",
    strokeWidth: 1.08248,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.618 17.2291H22.5392",
    stroke: "#1A1A18",
    strokeWidth: 1.08248,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5773 15.2048V14.3497",
    stroke: "#1A1A18",
    strokeWidth: 1.08248,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.998 20.2189C9.93461 22.871 9.46048 25.4993 9.37389 26.8827",
    stroke: "#1A1A18",
    strokeWidth: 1.08248,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M9.60141 24.9667C8.83718 24.4471 8.5146 23.5291 8.73109 22.6393C8.95842 21.6997 9.67502 20.968 10.4804 20.4787C11.5044 19.8574 12.7449 19.5066 13.9378 19.407C13.7257 20.05 13.7322 20.7537 13.6694 21.4226C13.5958 22.2172 13.4615 23.0182 13.0848 23.7326C12.4224 24.9927 10.922 25.8608 9.60141 24.9667Z",
    stroke: "#1A1A18",
    strokeWidth: 1.08248,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5188 20.2189C26.4554 22.871 25.9813 25.4993 25.8947 26.8827",
    stroke: "#1A1A18",
    strokeWidth: 1.08248,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1219 24.9667C25.3576 24.4471 25.0351 23.5291 25.2516 22.6393C25.4789 21.6997 26.1955 20.968 27.0008 20.4787C28.0249 19.8574 29.2654 19.5066 30.4583 19.407C30.2461 20.05 30.2526 20.7537 30.1898 21.4226C30.1162 22.2172 29.982 23.0182 29.6053 23.7326C28.9428 24.9927 27.4425 25.8608 26.1219 24.9667Z",
    stroke: "#1A1A18",
    strokeWidth: 1.08248,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOriginalTaste);
export default __webpack_public_path__ + "static/media/originalTaste.1157ae84fbbea4057bdd42d60b4137bb.svg";
export { ForwardRef as ReactComponent };